import { useGlobalContext } from "@/hooks/useGlobalContext";

import type { IANATimeZone } from "@/routes/adManager/AdsManagerUtils";

export function useRawAccountTimezone(): IANATimeZone | undefined {
  const { adAccountTimezone } = useGlobalContext();
  const normalizedTimezone = adAccountTimezone?.trim();
  return normalizedTimezone && normalizedTimezone.length > 0 ? normalizedTimezone : undefined;
}

export function useAccountTimezone(): IANATimeZone {
  return useRawAccountTimezone() ?? "UTC";
}
